module.exports = __webpack_public_path__ + "e40e413e.svg";